import {
  SelectionState,
  ProfileState,
  NavigationState,
} from '@alfresco/adf-extensions';
import {
  RepositoryInfo,
  ResultSetPaging,
  VersionEntry,
  UserRepresentation,
} from '@alfresco/js-api';
import { AppState as AlfrescoAppState } from '@adw/projects/aca-shared/store/src/public-api';

import { IKeyWords } from './keyword.state';
import {
  CitationRefModel,
  CitationUnnumberedRefModel,
  IPagination,
  IMarginaliaDeleteDialogData,
} from '../../model';

export interface AppState extends AlfrescoAppState {
  headerTextColor: string;
  selection: SelectionState;
  user: ProfileState;
  navigation: NavigationState;
  currentNodeVersion: VersionEntry;
  infoDrawerOpened: boolean;
  infoDrawerPreview: boolean;
  infoDrawerMetadataAspect: string;
  fileUploadingDialog: boolean;
  uploadCompleted?: boolean;
  documentDisplayMode: string;
  showLoader: boolean;
  repository: RepositoryInfo;
  sites?: any;
  currentSite?: string;
  siteChildren?: any;
  contentWidgetAssigneeState?: string;
  isSiteManager: boolean;
  bpmUser: UserRepresentation;
  keyWords: IKeyWords;
  allDocsDashboardSelection: any;
  editorRedo: {
    keywords: IKeyWords[];
  };
  editorUndo: {
    keywords: IKeyWords[];
  };
  currentSiteUserRole: string;
  citations: {
    references: CitationRefModel[];
    unnumbered_references: CitationUnnumberedRefModel[];
  };
  latestEditorContent: string;
  pagination: IPagination;
  paginationData?: ResultSetPaging;
  targetDeleteDialogData: IMarginaliaDeleteDialogData;
  searchItemsTotalCount: number;
  featureFlagsState: {
    flags: { [key: string]: boolean };
  };
  selectedDocumentState: Array<{ id: string; name: string; url?: string }> | [];
  selectedRowsState?: Array<any>;
}

const INITIAL_TARGET_DIALOG_DATA: IMarginaliaDeleteDialogData = {
  sources: [],
  citations: [],
};

const INITIAL_PAGINATION_DATA: ResultSetPaging = {
  list: {
    pagination: {
      count: 0,
      hasMoreItems: false,
      totalItems: 0,
      skipCount: 0,
      maxItems: 10,
    },
    context: {
      consistency: {
        lastTxId: 0,
      },
    },
    entries: [],
  },
};

export const INITIAL_APP_STATE: AppState = {
  headerTextColor: '#000000',
  user: {
    isAdmin: null,
    id: null,
    firstName: '',
    lastName: '',
  },
  selection: {
    nodes: [],
    libraries: [],
    isEmpty: true,
    count: 0,
  },
  navigation: {
    currentFolder: null,
  },
  currentNodeVersion: null,
  infoDrawerOpened: false,
  infoDrawerPreview: false,
  infoDrawerMetadataAspect: '',
  fileUploadingDialog: true,
  documentDisplayMode: 'list',
  showLoader: false,
  repository: {
    status: {
      isQuickShareEnabled: true,
    },
  } as any,
  sites: [],
  currentSite: '',
  siteChildren: [],
  contentWidgetAssigneeState: 'My',
  isSiteManager: false,
  bpmUser: null,
  keyWords: {
    allId: [],
    byId: {},
    formattedKeyword: [],
    allKeyword: [],
  },
  allDocsDashboardSelection: [],
  editorRedo: {
    keywords: [],
  },
  editorUndo: {
    keywords: [],
  },
  currentSiteUserRole: '',
  citations: { references: [], unnumbered_references: [] },
  latestEditorContent: '',
  pagination: {
    currentSite: null,
    mediaType: null,
    searchField: null,
    paging: {
      maxItems: 10,
      skipCount: 0,
    },
  },
  paginationData: INITIAL_PAGINATION_DATA,
  uploadCompleted: false,
  targetDeleteDialogData: INITIAL_TARGET_DIALOG_DATA,
  searchItemsTotalCount: null,
  featureFlagsState: {
    flags: {},
  },
  selectedDocumentState: [],
  selectedRowsState: [],
};

export interface AppStore {
  app: AppState;
}

export const INITIAL_STATE: AppStore = {
  app: INITIAL_APP_STATE,
};

export const selectedDocumentState: Array<{
  id: string;
  name: string;
  url?: string;
}> = [];
